import { Injectable } from '@angular/core';
import { RestApiService, PaginatedResponse } from './rest-api.service';
import { Observable } from 'rxjs';
import { CompanyPointWallet } from '../models/app.model';

@Injectable({
  providedIn: 'root'
})
export class ApiCompanyPointWalletService extends RestApiService {

  public apiGetObjects(params: any = {}): Observable<PaginatedResponse<CompanyPointWallet>> {
    return this.getList('company-point-wallets/', CompanyPointWallet.parse, params);
  }

  public apiGetObject(id: any, params: any = {}): Observable<CompanyPointWallet> {
    return this.getSingle(`company-point-wallets/${id}/`, CompanyPointWallet.parse, params);
  }

  public apiPostObject(payload: any, params: any = {}): Observable<CompanyPointWallet> {
    return this.postSingle('company-point-wallets/', payload, CompanyPointWallet.parse, params);
  }

  public apiGetByCompany(params: any = {}): Observable<CompanyPointWallet> {
    return this.getSingle('company-point-wallets/get-by-company/', CompanyPointWallet.parse, params);
  }

  public apiDeposit(id: any, payload: any, params: any = {}): Observable<CompanyPointWallet> {
    return this.postSingle(`company-point-wallets/${id}/deposit/`, payload, CompanyPointWallet.parse, params);
  }

  public apiWithdraw(id: any, payload: any, params: any = {}): Observable<CompanyPointWallet> {
    return this.postSingle(`company-point-wallets/${id}/withdraw/`, payload, CompanyPointWallet.parse, params);
  }
}
